function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.364 8.45c-6.842 0-11.434 4-11.434 11.767v5.533a5.113 5.113 0 012.214-.507c.802 0 1.56.19 2.238.52v-5.546c0-5.036 2.765-7.625 6.982-7.625 4.217 0 6.981 2.588 6.981 7.625v12.095h4.452V20.217c0-7.813-4.592-11.766-11.433-11.766zM57.449 18.288c-.892-3.701-3.94-5.715-7.692-5.715-3.846 0-6.753 2.06-7.644 5.715h15.336zM37.282 20.63c0-7.026 5.158-12.18 12.474-12.18s12.38 5.154 12.38 12.18v1.64H41.973c.657 4.121 3.752 6.416 7.785 6.416 3.001 0 5.112-.937 6.472-2.95h4.924c-1.782 4.31-6.002 7.073-11.396 7.073-7.316 0-12.474-5.153-12.474-12.18zM84.496 20.63c0-4.685-3.177-8.057-7.943-8.057-4.765 0-7.941 3.372-7.941 8.056 0 4.685 3.176 8.057 7.941 8.057 4.766 0 7.943-3.372 7.943-8.057zm-20.37 0c0-7.027 5.14-12.18 12.427-12.18 7.288 0 12.428 5.153 12.428 12.18 0 7.026-5.14 12.179-12.428 12.179-7.288 0-12.427-5.153-12.427-12.18zM114.333 36.934h.517c2.874 0 3.957-1.261 3.957-4.529V9.445h4.474v22.68c0 5.696-2.26 8.637-8.007 8.637h-.941v-3.828zM95.734 23.539c-.13.184-.205.41-.205.654 0 .623.49 1.126 1.103 1.126h11V10.97a1.098 1.098 0 00-.764-1.09 1.372 1.372 0 00-.397-.056c-.268 0-.6.096-.873.47l-9.861 13.24-.003.004zm16.29 11.258h-4.392v-5.513H96.494c-2.222 0-4.15-1.109-5.033-2.892-.826-1.67-.602-3.649.6-5.296L102.07 7.75c1.441-1.977 3.861-2.76 6.158-1.99 2.299.77 3.789 2.858 3.795 5.321v14.238h3.303v3.965h-3.303v5.513z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M117.316 0h7.456v7.457h-7.456V0z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#aura-db-ent-colored_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M117.316 3.729a3.732 3.732 0 003.728 3.728 3.733 3.733 0 003.729-3.728A3.733 3.733 0 00121.044 0a3.732 3.732 0 00-3.728 3.729z",
  fill: "#018BFF"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 19.884h17.896v21.375H0V19.884z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#aura-db-ent-colored_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.057 26.78c-.866 0-1.663.29-2.306.77L7.529 24.7c.093-.327.146-.67.146-1.026 0-2.09-1.721-3.79-3.837-3.79-2.117 0-3.838 1.7-3.838 3.79 0 2.091 1.721 3.79 3.838 3.79.866 0 1.664-.287 2.307-.767l4.22 2.85a3.73 3.73 0 00-.145 1.025c0 .355.053.698.146 1.025l-4.221 2.85a3.843 3.843 0 00-2.307-.77C1.72 33.678 0 35.379 0 37.47c0 2.09 1.721 3.79 3.838 3.79 2.116 0 3.837-1.7 3.837-3.79a3.75 3.75 0 00-.146-1.025l4.222-2.85c.643.48 1.44.768 2.306.768 2.117 0 3.839-1.7 3.839-3.79s-1.722-3.791-3.839-3.791z",
  fill: "#018BFF"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M142.894 29.985c3.006 0 5.574-1.472 6.671-4.228v3.82h1.941v-7.641c0-4.886-3.413-8.236-8.299-8.236-4.885 0-8.33 3.413-8.33 8.236 0 4.948 3.664 8.049 8.017 8.049zm.313-1.942c-3.695 0-6.201-2.63-6.201-6.2 0-3.571 2.506-6.202 6.201-6.202 3.696 0 6.201 2.63 6.201 6.201 0 3.57-2.505 6.2-6.201 6.2zm23.732 1.942c4.573 0 7.642-2.662 7.642-7.798v-8.08h-2.099v8.08c0 3.789-2.192 5.856-5.543 5.856s-5.543-2.067-5.543-5.856v-8.08h-2.098v8.08c0 5.136 3.069 7.798 7.641 7.798zm17.531-.407v-9.27c0-3.226 1.754-4.667 4.416-4.667 2.631 0 4.416 1.44 4.416 4.667v.219h2.067v-.188c0-4.478-2.631-6.64-6.483-6.64s-6.514 2.162-6.514 6.609v9.27h2.098zm25.079.407c3.007 0 5.575-1.472 6.671-4.228v3.82h1.941v-7.641c0-4.886-3.413-8.236-8.299-8.236-4.885 0-8.33 3.413-8.33 8.236 0 4.948 3.664 8.049 8.017 8.049zm.313-1.942c-3.695 0-6.201-2.63-6.201-6.2 0-3.571 2.506-6.202 6.201-6.202 3.696 0 6.201 2.63 6.201 6.201 0 3.57-2.505 6.2-6.201 6.2z",
  fill: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M231.583 29.826c5.549 0 8.519-3.216 8.519-8.029 0-4.812-2.97-8.029-8.519-8.029h-5.746v16.058h5.746zm0-1.62h-3.978V15.389h3.978c4.542 0 6.752 2.553 6.752 6.408 0 3.855-2.21 6.409-6.752 6.409zM254.864 29.826c2.971 0 4.616-1.792 4.616-4.248 0-1.988-1.154-3.56-3.045-4.05v-.05c1.449-.614 2.308-1.94 2.308-3.634 0-2.381-1.596-4.076-4.517-4.076h-7.759v16.058h8.397zm-.761-8.986h-5.868v-5.451h5.794c2.063 0 2.946 1.13 2.946 2.725 0 1.596-1.031 2.726-2.872 2.726zm.54 7.366h-6.408V22.46h6.457c1.866 0 2.996 1.203 2.996 2.873 0 1.67-.983 2.873-3.045 2.873z",
  fill: "#018BFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M288.194 32.56c6.52 0 11.806-5.286 11.806-11.806s-5.286-11.806-11.806-11.806-11.806 5.286-11.806 11.806 5.286 11.806 11.806 11.806z",
  fill: "#FEDE64"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M284.009 15.075h8.369v2.067h-6.146v2.535h5.139v1.98h-5.139v2.727h6.146v2.049h-8.369V15.075z",
  fill: "#000"
});

function SvgAuraDbEntColored(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "aura-db-ent-colored_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 0,
    width: 8,
    height: 8
  }, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "aura-db-ent-colored_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 18,
    height: 23
  }, _ref5), _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgAuraDbEntColored;